import React from 'react'
import TermsConditionBanner from './Components/TermsConditionBanner'
import TermsConditionBody from './Components/TermsConditionBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function TermsConditionPage() {
  const page = 'terms-of-use'
  return (
    <>
        {/* topbar */}
        <SEOHelmet page={page} />
        <div className='bg-About main'>
          {/* <TopBar/> */}
          <TermsConditionBanner/>
        </div>
        <TermsConditionBody/>
        <IndexFooter/>
    </>
  )
}

export default TermsConditionPage